import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material';
import SteppedCheckout from '../../blocks/Checkout/SteppedCheckout';
import OrderSummarySteppedWrapper from '../../blocks/Checkout/OrderSummarySteppedWrapper';

import OrderSummary from '../../blocks/Checkout/OrderSummary';
import OrderTotalSummary from '../../blocks/Checkout/OrderTotalSummary';
import { CloverProvider } from '../../contexts/CloverContext';
import store from '../../store';
import messages from '../../i18n';
import ProviderWrapper from '../../provider';
import { OrderSummaryDataSources } from '../../hooks/useOrderDataSource';
import { purpleTheme } from '../../themes/default';
import { ShopPayProvider } from '../../contexts/ShopPayContext';

const locale = 'en-US';

const queryClient = new QueryClient();

const mainPageContainer = document.getElementById('main-page');
if (mainPageContainer) {
  const mainPageRoot = createRoot(mainPageContainer);
  mainPageRoot.render(
    <QueryClientProvider client={queryClient}>
      <IntlProvider
        messages={messages[locale]}
        locale={locale}
        defaultLocale="en"
      >
        <ThemeProvider theme={purpleTheme()}>
          <ProviderWrapper>
            <ShopPayProvider>
              <CloverProvider>
                <SteppedCheckout />
              </CloverProvider>
            </ShopPayProvider>
          </ProviderWrapper>
        </ThemeProvider>
      </IntlProvider>
    </QueryClientProvider>,
  );
}

const cartSummaryContainer = document.getElementById('cart-summary');
if (cartSummaryContainer) {
  const cartSummaryRoot = createRoot(cartSummaryContainer);
  cartSummaryRoot.render(
    <QueryClientProvider client={queryClient}>
      <IntlProvider
        messages={messages[locale]}
        locale={locale}
        defaultLocale="en"
      >
        <ThemeProvider theme={purpleTheme()}>
          <Provider store={store}>
            <OrderSummarySteppedWrapper
              dataSource={OrderSummaryDataSources.CART}
            >
              <OrderSummary dataSource={OrderSummaryDataSources.CART} />
              <OrderTotalSummary isSteppedCheckout />
            </OrderSummarySteppedWrapper>
          </Provider>
        </ThemeProvider>
      </IntlProvider>
    </QueryClientProvider>,
  );
}
